
import { ElMessage } from "element-plus";
import { getEnum, login } from "@/api/index";
import Uploadimg from "@/components/uploadimg/Index.vue";
import { useStore } from "vuex";
import { ElForm } from "element-plus";
 
import { putCustomer } from "@/api/backstage";
import {
  defineComponent,
  reactive,
  computed,
  ref,
  unref,
  toRefs,
  watch,
  onMounted,
} from "vue";
export default defineComponent({
  name: "新增经典客户",
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    row: {
      type: Object,
      default: () => {
        return null;
      },
    },
  },
  components: {
    Uploadimg,
  },
  emits: ["close"],
  setup(opt, contex) {
    const ruleFormRef = ref(ElForm);
    let isEdit = false;
    let show = opt.open;
    const store = useStore();

    const dataMap: any = reactive({
      customerType:'',
      ruleForm: {
        orgName: "",
        fileId:'',
        customerType:'',
        fileName:'',
        sortNum: "",
        isTop:false,
        imgId:'',
        imgName:'',
      },
      rules: {
        orgName: [
          { required: true, message: "请输入客户名称", trigger: "blur" },
        ],
         customerType: [
          { required: true, message: "请输选择客户类型", trigger: "blur" },
        ],
      },

      async putNewData() {
        dataMap.ruleForm.isTop? (dataMap.ruleForm.isTop = 1) : (dataMap.ruleForm.isTop =0);
        const res = await putCustomer(dataMap.ruleForm);
        if (res.code === 200) {
          ElMessage({
            message: "操作成功",
            type: "success",
          });
          contex.emit("close", false);
        } else {
          ElMessage({
            message: res.msg,
            type: "error",
          });
        }
      },
       async getCoustemType() {
        dataMap.customerType = {};
        const menus = await getEnum("CUSTOMER");
        for (const item of menus.data) {
          dataMap.customerType[item.enumKey] = item;
        }
      },
    });

    if (opt.row) {
      isEdit = true;
      dataMap.ruleForm = opt.row;
       dataMap.ruleForm.isTop ===  1 ? (dataMap.ruleForm.isTop = true)  : (dataMap.ruleForm.isTop = false);
      if(opt.row.fileName) dataMap.ruleForm.fileUrl =  localStorage.getItem("fileUrel") + opt.row.fileName;
      if(opt.row.imgName) dataMap.ruleForm.imgUrl =  localStorage.getItem("fileUrel") + opt.row.imgName;
    }

    const submitForm = () => {
      const form = unref(ruleFormRef);
      form.validate((valid: any) => {
        if (valid) {
          dataMap.putNewData();
        } else {
          console.log("error submit!");
          return false;
        }
      });
    };

    const close = () => {
      const form = unref(ruleFormRef);
      contex.emit("close", false);
    };

    const onSuccess = (val: any) => {
      dataMap.ruleForm.fileId = val.id;
      dataMap.ruleForm.fileName = val.fileName;
    };

    const imgSuccess = (val: any) => {
      console.log(val);
      
      dataMap.ruleForm.imgId = val.id;
      dataMap.ruleForm.imgName = val.fileName;
    };

    onMounted(() => {
      dataMap.getCoustemType();
    });
    return {
      show,
      store,
      isEdit,
      ruleFormRef,
      submitForm,
      onSuccess,
      close,
      imgSuccess,
      ...toRefs(dataMap),
    };
  },
});
